var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook 1",
    clipPath: "url(#clip0_521_7826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9088 0.727051C8.82267 0.727051 5.86291 1.953 3.68067 4.13522C1.49843 6.31743 0.272461 9.27714 0.272461 12.3633C0.272461 15.4494 1.49843 18.4091 3.68067 20.5913C5.86291 22.7735 8.82267 23.9995 11.9088 23.9995C14.995 23.9995 17.9547 22.7735 20.137 20.5913C22.3192 18.4091 23.5452 15.4494 23.5452 12.3633C23.5452 9.27714 22.3192 6.31743 20.137 4.13522C17.9547 1.953 14.995 0.727051 11.9088 0.727051Z",
    fill: "#ADAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4839 15.4477H16.4953L16.9681 12.3886H13.4833V10.7167C13.4833 9.44588 13.8985 8.31901 15.0873 8.31901H16.9975V5.64942C16.6618 5.6041 15.952 5.50488 14.6108 5.50488C11.8101 5.50488 10.1681 6.98391 10.1681 10.3535V12.3886H7.28906V15.4477H10.1681V23.8558C10.7383 23.9415 11.3159 23.9997 11.9087 23.9997C12.4446 23.9997 12.9676 23.9507 13.4839 23.8809V15.4477Z",
    fill: "#EEEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_7826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2727,
    height: 23.2727,
    fill: "white",
    transform: "translate(0.272461 0.727295)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3ff4aad5bf4b8cf290897452eeb86f1a.svg";
export { ForwardRef as ReactComponent };